/**
 * Open-Meteo's `timezone=auto` responses give `current.time`/`hourly.time` as naive local
 * wall-clock strings with no UTC designator (e.g. "2026-08-04T14:00"). Parsing those with the
 * bare `Date` constructor reads them as local time in the *browser's* zone, not the ZIP's — so
 * everywhere except the viewer's own timezone renders the wrong hour. Recover the real UTC
 * instant using the ZIP's known UTC offset before doing anything else with the timestamp.
 */
export function zipInstant(isoString, utcOffsetSeconds) {
  if (!isoString) return null;
  const hasZone = /[Zz]|[+-]\d{2}:\d{2}$/.test(isoString);
  const asIfUtc = new Date(hasZone ? isoString : `${isoString}Z`);
  if (hasZone || utcOffsetSeconds == null) return asIfUtc;
  return new Date(asIfUtc.getTime() - utcOffsetSeconds * 1000);
}

/** Short IANA timezone abbreviation (e.g. "PDT", "CDT") for a given instant, or '' if unknown. */
export function tzAbbreviation(date, timeZone) {
  if (!timeZone || !date) return '';
  try {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' }).formatToParts(date);
    return parts.find((p) => p.type === 'timeZoneName')?.value ?? '';
  } catch {
    return '';
  }
}
